import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const RouteDelay = (props) => {
  const {
    className,
    delay,
    showIcon,
    showTime,
  } = props;

  if (!delay || (delay.asMinutes() > -10 && delay.asMinutes() < 30)) {
    return null;
  }

  const rootClassName = classnames("RouteDelay", className, {
    "text-success": delay < 0,
    "text-warning": delay > 0,
  });

  const iconClassName = classnames("fa", {
    "fa-angle-up": delay < 0,
    "fa-angle-down": delay > 0,
  });

  return (
    <span className={rootClassName}>
      {showIcon && <i className={iconClassName} />}
      {" "}
      {showTime && delay.hours() ? `${Math.abs(delay.hours())}h `: null }
      {showTime && delay.minutes() ? `${Math.abs(delay.minutes())}m`: null }
    </span>
  );
};

RouteDelay.defaultProps = {
  showIcon: true,
  showTime: true,
};

RouteDelay.propTypes = {
  className: PropTypes.string,
  delay: PropTypes.object, // moment.duration
  showIcon: PropTypes.bool,
  showTime: PropTypes.bool,
};

export default RouteDelay;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RouteDelay.js
 **/